import React from 'react';
import AnimatedNumber from 'react-animated-number';
import DialogCollapseSection from "../DialogCollapseSection/DialogCollapseSection";
import {Button, Col, Row, UncontrolledTooltip} from "reactstrap";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';

export const FixedValueDisplay = ({ id , value , message  , duration , hint }) => {

    return <span id={id} style={{
        cursor: "pointer"
    }}><AnimatedNumber value={value}
                       duration={duration || 400}
                       formatValue={(number) =>  Math.floor(number).toLocaleString('en-us', { minimumFractionDigits: 0 })}
                       style={{
                           transition: '0.8s ease-out',
                           transitionProperty: 'background-color, color, opacity',
                           fontSize: 'larger',
                           fontWeight: 'bold',
                           marginRight: 6
                       }}/>

        {message && <small className="text-uppercase font-weight-bold">{message}</small>}

        {hint && <UncontrolledTooltip key="tip" delay={10} autohide={false} target={id}>
            {hint}
        </UncontrolledTooltip>}


    </span>;
};

export default class OperationSummaryComponent extends React.Component {

    static Ranges = [
        {
            label: "Overall",
            value: "overall"
        },
        {
            label: "Today",
            value: "today"
        },
        {
            label: "This Week",
            value: "week"
        },
        {
            label: "This Month",
            value: "month"
        },
        {
            label: "This Year",
            value: "year"
        },
        {
            label: "Custom",
            value: "custom"
        }
    ];

    static propTypes = {
        renderRevenueStats: PropTypes.func,
        renderOperationStats: PropTypes.func,
        operationSummary: PropTypes.object,
        onQuery: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = {
            statsTimeRange: "overall",
            startQueryDate: null,
            endQueryDate: null
        };

        this._isMounted = false;
    }

    componentDidMount(){
        this._isMounted = true;
    }

    setStateSafe(state,callback){

        if(this._isMounted){
            return this.setState(state,callback);
        }

    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    hasValidTimeRange(){
        return this.state.startQueryDate && this.state.endQueryDate;
    }

    refreshStatsQuery(){

        const { onQuery  } = this.props;
        let customRange;
        if(this.hasValidTimeRange() && this.state.statsTimeRange === "custom"){
            customRange = { from : moment(this.state.startQueryDate).toDate().toJSON() , to : moment(this.state.endQueryDate).toDate().toJSON() };
        }

        return onQuery(this.state.statsTimeRange , customRange);
    }

    render(){

        const { statsTimeRange  } = this.state;
        const operationSummary = this.props.operationSummary;

        return   <div style={{
            padding: 12,
            backgroundColor: "#f5f5f5",
            borderRadius: 4
        }}>

            <div className="clearfix">

                <div className="pull-left">
                    <h5>Statistics</h5>
                    {operationSummary && <p>Total Requests: <b>{operationSummary.totalRequests.toLocaleString('en-us', { minimumFractionDigits: 0 })}</b></p>}
                </div>

                <div className="pull-right">

                    <select value={statsTimeRange}
                            className="form-control"
                            onChange={evt => {
                                const value = evt.target.value;
                                this.setStateSafe({ statsTimeRange: value }, () => {

                                    if(value !== "custom") {
                                        this.refreshStatsQuery();
                                    }

                                });
                            }}
                            style={{
                                padding: 2,
                                borderRadius: 5,
                                height: 30
                            }}>
                        {OperationSummaryComponent.Ranges.map((x,key) => (<option key={key} value={x.value}>{x.label}</option>))}
                    </select>

                </div>

            </div>

            {statsTimeRange === "custom" && <Row>

                <Col md={5}>

                    <div><i className="fa fa-calendar"/> Start: <DatePicker autoFocus={true}
                                                                            selected={this.state.startQueryDate }
                                                                            isClearable
                                                                            onChange={date => {

                                                                                this.setStateSafe({
                                                                                    startQueryDate: date
                                                                                });

                                                                            }} /> </div>

                </Col>

                <Col md={2}>

                    <div>
                        <Button size={"sm"} disabled={!this.hasValidTimeRange()} style={{ borderRadius: 4 , marginTop: 14}} onClick={() => this.refreshStatsQuery()}><i className="fa fa-refresh"/> Load</Button>
                    </div>

                </Col>

                <Col md={5}>
                    <div><i className="fa fa-calendar"/> End: <DatePicker selected={this.state.endQueryDate || null} isClearable onChange={date => {
                        this.setStateSafe({
                            endQueryDate: date
                        })
                    }}/> </div>
                </Col>

            </Row>}

            <hr/>

            <DialogCollapseSection title={<h6><i className="fa fa-tasks"/> Operation</h6>} initiallyOpen={false}>

                {operationSummary ? (this.props.renderOperationStats(operationSummary)) : <div className="text-center">
                    <p>Operation summary not available!</p>
                </div>}

            </DialogCollapseSection>

            <DialogCollapseSection title={<h6><i className="fa fa-money"/> Revenue</h6>} initiallyOpen={false}>

                {operationSummary ? this.props.renderRevenueStats(operationSummary) : <div className="text-center">
                    <p>Revenue statistics not available!</p>
                </div>}

            </DialogCollapseSection>

        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/OperationSummaryComponent/OperationSummaryComponent.js